<template>
  <v-dialog 
    :value="show" 
    @input="$emit('update:show', $event)"
    fullscreen 
    hide-overlay 
    transition="dialog-bottom-transition"
  >
    <v-card color="#141616"> 
      <v-toolbar dark>
        <v-btn icon dark @click="$emit('update:show', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Συγκεντρωτικό Δελτίο Αποστολής</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      
      <v-card v-if="sdaData && sdaData.SDAInv" class="ma-4">
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div class="sda-inv-details-condensed">
                <div class="detail-row">
                  <span class="label">Ημερομηνία:</span>
                  <span class="value">{{ formatDate(sdaData.SDAInv.Hmerom) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Αριθμός Παραστατικού:</span>
                  <span class="value">{{ sdaData.SDAInv.NumberPar }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Invoice Mark:</span>
                  <span class="value">{{ sdaData.SDAInv.invoiceMark }}</span>
                </div>
                <div class="detail-row" v-if="sdaData.SDAInv.HmeromExpire">
                  <span class="label">Ημ. Λήξης:</span>
                  <span class="value">{{ formatDate(sdaData.SDAInv.HmeromExpire) }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div v-if="sdaData.SDAInv.qrURL">
                <vue-qrcode :value="sdaData.SDAInv.qrURL" :size="180" class="mr-2" />
                <v-btn
                  color="primary"
                  :href="sdaData.SDAInv.qrURL"
                  target="_blank"
                  text
                  small
                >
                  Άνοιγμα QR URL
                  <v-icon right small>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>       
          <v-alert v-if="isSDAExpired" type="error" outlined class="mb-2">
            Το Συγκεντρωτικό Δελτίο έχει λήξει. Πρέπει να το ανανεώσετε για να συνεχίσετε.
          </v-alert>
        </v-card-text>
      </v-card>
    
      <v-card class="ma-4">
        <v-card-title>      
          Ενέργειες Συγκεντρωτικού ΔΑ
        </v-card-title>
        <v-card-text>
          <v-alert 
            v-if="sdaData && sdaData.SDAInv && sdaData.SDAInv.StandBy > 0" 
            type="warning"  
            color="#dfcd0088" 
            class="mt-2"
          >
            Υπάρχουν ({{ sdaData.SDAInv.StandBy }}) ΔΑ σε αναμονή, που δεν έχουν εκδοθεί. Παρακαλώ επικοινωνήστε με το γραφείο σας. Δεν μπορείτε να κάνετε ανανέωση ή κλείσιμο.
          </v-alert>
        </v-card-text>
    
        <v-alert type="info" color="grey" outlined class="ma-2">
          <div>
            <strong>ΑΝΑΝΕΩΣΗ:</strong> Εκδίδει νέο ΣΔΑ με τρέχοντα αποθέματα για 5 ακόμα μέρες.
          </div>
          <div class="mt-2">
            <strong>ΚΛΕΙΣΙΜΟ:</strong> Επιστρέφει τα προϊόντα του ΣΔΑ στην αποθήκη.
          </div>
        </v-alert>
        <v-card-actions>
          <v-btn
            color="warning"
            elevation="2"
            large
            rounded
            outlined
            class="mt-2"
            @click="$emit('close-sda')"
            :disabled="sdaData && sdaData.SDAInv.StandBy > 0"
          >
            <v-icon left>mdi-close</v-icon>
            ΚΛΕΙΣΙΜΟ 
          </v-btn>
          <v-btn
            color="primary"
            elevation="2"
            large
            rounded 
            outlined
            class="mt-2"
            @click="$emit('refresh-sda')"
            :disabled="sdaData && sdaData.SDAInv.StandBy > 0"
          >
            <v-icon left>mdi-refresh</v-icon>
            ΑΝΑΝΕΩΣΗ 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrcode from 'qrcode.vue'
import moment from 'moment'

export default {
  name: 'SDAInvDialog',
  components: {
    VueQrcode
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    sdaData: {
      type: Object,
      default: null
    },
    isSDAExpired: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YY')
    }
  }
}
</script>

<style scoped>
.sda-inv-details-condensed {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 15px;
}
.label {
  font-weight: 500;
}
.value {
  font-weight: 400;
}
</style> 